/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Turnstilefailed1Inputs */

const he_contact_turnstilefailed1 = /** @type {(inputs: Contact_Turnstilefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אימות האבטחה נכשל. אנא נסה שוב.`)
};

const en_contact_turnstilefailed1 = /** @type {(inputs: Contact_Turnstilefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security verification failed. Please try again.`)
};

/**
* | output |
* | --- |
* | "Security verification failed. Please try again." |
*
* @param {Contact_Turnstilefailed1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_turnstilefailed1 = /** @type {((inputs?: Contact_Turnstilefailed1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Turnstilefailed1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_turnstilefailed1(inputs)
	return en_contact_turnstilefailed1(inputs)
});
export { contact_turnstilefailed1 as "contact_turnstileFailed" }